import { copy, equals } from '@/helpers/object';
import HeadhunterOptionsItem from '@/interface/HeadhunterOptionsItem';
import BookmarkedAttrs from '@/interface/BookmarkedAttrs';

import { encodeExposedFilterParams, filtersToSearchRawParams } from '@/helpers/headhunter-filters';
import {
  saveLastHeadhunterSearchFilters,
} from '@/helpers/last-search';

const mainFiltersList = ['professions', 'city'];

const state = () => ({
  isListRequestPending: false,
  isInitialLoading: false,
  cancelListRequest: null,
  list: [],

  isFacetsRequestPending: false,
  cancelFacetsRequest: null,
  facets: null,

  requestParams: null,
  data: null,

  isSubmitted: false,

  mainFilters: {},
  extraFilters: {},
  page: 1,

  lastFilters: {},
});

// mutations
const mutations = {
  setSubmitted(currentState, newValue) {
    currentState.isSubmitted = newValue;
  },

  clearState(currentState) {
    Object.assign(currentState, {
      isSubmitted: false,

      list: [],
      facets: null,

      requestParams: null,

      mainFilters: {},
      extraFilters: {},
    });
  },

  setListRequestPending(currentState, boolean) {
    currentState.isListRequestPending = boolean;
  },
  setIsInitialLoading(currentState, boolean) {
    currentState.isInitialLoading = boolean;
  },
  setFacetsRequestPending(currentState, boolean) {
    currentState.isFacetsRequestPending = boolean;
  },
  setRequestParams(currentState, params) {
    currentState.requestParams = params;
  },
  setList(currentState, newValue: unknown) {
    currentState.list = newValue;
  },
  setFacets(currentState, value) {
    currentState.facets = value;
  },
  setData(currentState, newValue: unknown) {
    currentState.data = newValue;
  },

  setMainFilters(currentState, newValue) {
    currentState.mainFilters = {
      ...currentState.mainFilters,
      ...JSON.parse(JSON.stringify(newValue)),
    };
  },
  setExtraFilters(currentState, newValue) {
    currentState.extraFilters = {
      ...currentState.extraFilters,
      ...JSON.parse(JSON.stringify(newValue)),
    };
  },
  setLastFilters(currentState, value: string) {
    saveLastHeadhunterSearchFilters(value);
    currentState.lastFilters = value;
  },
  setBookmarked(currentState, { index, item }) {
    currentState.list.splice(index, 1, item);
  },
};

// actions
const actions = {
  cancelPendingRequests({ state: currentState }) {
    if (currentState.cancelListRequest) {
      currentState.cancelListRequest();
    }

    if (currentState.cancelFacetsRequest) {
      currentState.cancelFacetsRequest();
    }
  },

  fetch({ state: currentState, commit, dispatch, getters }) {
    dispatch('cancelPendingRequests');
    dispatch('saveFilters', getters.filters);

    commit('setRequestParams', filtersToSearchRawParams(getters.filters));

    return [
      dispatch('fetchList', currentState.requestParams),
      dispatch('fetchFacets', currentState.requestParams),
    ];
  },
  fetchList({ commit, getters }, filters) {
    commit('setListRequestPending', true);
    commit('setList', []);

    const cancelTokenSource = this.$api.CancelToken.source();

    return this.$api
      .post(this.getters.getApiLink('headhunterSearch.execute_v2'), filters, {
        cancelToken: cancelTokenSource.token,
      })
      .then(({ data }) => {
        // data = {"message":"","resultList":[{"id":"449e6ae1a6b4b124fbdad6bd07a0922d","cid":5745,"name":"Headhunter 5370645","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/5/7/4/5/rslogofrU28D.png","match":100,"jobs":294,"activity":4,"bookmarked":false},{"id":"e66385007ee76b32e01e63adf20c7b0d","cid":9881,"name":"Headhunter 5374781","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/8/8/1/p_https___www.amadeus-fire.de_fileadmin_layout_img_logo-header-default.jpg","match":99,"jobs":196,"activity":4,"bookmarked":false},{"id":"dd22888a07df4b5deeed5fe4fc2e66fd","cid":11543,"name":"Headhunter 5376443","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/1/1/5/4/3/p_https___www.persona.de_fileadmin_templates_images_logo.jpg","match":98,"jobs":159,"activity":3,"bookmarked":false},{"id":"459c786aa2410805f3f46224360b2e7c","cid":51094,"name":"Headhunter 5415994","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/5/1/0/9/4/p_https___www.xing.com_img_custom_cp_assets_logo_f_3_e_65342_logo_Logo_final.jpg","match":97,"jobs":67,"activity":1,"bookmarked":false},{"id":"9c9fe38372843cf36311cb4748044299","cid":10419,"name":"Headhunter 5375319","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/1/0/4/1/9/p_https___de.experis.com_typo3conf_ext_nidag_template_Resources_Public_Experis_Images_logo.jpg","match":97,"jobs":66,"activity":2,"bookmarked":false},{"id":"5d11700386fd64a66ddb1755bf4e4a2d","cid":11673,"name":"Headhunter 5376573","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/1/1/6/7/3/p_http___www.tremonia.de_media_layout_logo.jpg","match":96,"jobs":55,"activity":4,"bookmarked":false},{"id":"6ed69730a17ec8b89f95c4595be78a11","cid":9727,"name":"Headhunter 5374627","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/7/2/7/p_http___www.pink-personal.de_fileadmin_images_png_pink_logo.jpg","match":95,"jobs":39,"activity":3,"bookmarked":false},{"id":"c583b72771ba394c7c0ce19e04eb6a7e","cid":9362,"name":"Headhunter 5374262","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/3/6/2/p_https___www.pluss.de_typo3conf_ext_const_package_Resources_Public_Images_Logos_20150217_Pluss_Logo_RGB_Hauptlogo_ohne_Claim.jpg","match":95,"jobs":33,"activity":2,"bookmarked":false},{"id":"4cc8e4cf11e930fb2e505313629e4c22","cid":9329,"name":"Headhunter 5374229","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/3/2/9/p_http___www.pedimasued.de_images_logo.jpg","match":94,"jobs":31,"activity":1,"bookmarked":false},{"id":"bd1abebe75797e357ede5c1c39a81423","cid":9241,"name":"Headhunter 5374141","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/2/4/1/p_http___gess-group.de_bundles_gessgroup_general_images_colorshift_gess_group_main_logo_25.jpg","match":93,"jobs":24,"activity":2,"bookmarked":false},{"id":"32590517c60efc1abb5066b3817bbee5","cid":9541,"name":"Headhunter 5374441","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/5/4/1/p_https___www.xing.com_img_custom_cp_assets_logo_c_d_c_19676_logo_Logo_Agentur_mit_Beratungsfeldern20140304-11365-xbvxip.jpg","match":93,"jobs":15,"activity":2,"bookmarked":false},{"id":"86578295914b7d415e499d398ec10089","cid":10441,"name":"Headhunter 5375341","logo":"/resources/company/default_logos/officeBlurred.png","match":92,"jobs":14,"activity":3,"bookmarked":false},{"id":"bed99070c774e6d474a2eb8f74beffd5","cid":9696,"name":"Headhunter 5374596","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/6/9/6/p_http___www.gruppenintelligenz.de_blog_wp-content_uploads_2014_07_MaximumPersonal_logo_38-e1404572254320-300x80.jpg","match":91,"jobs":14,"activity":2,"bookmarked":false},{"id":"4b6b0af29856e10d756cb1d4d94bc12c","cid":9475,"name":"Headhunter 5374375","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/4/7/5/p_http___www.victoria-consulting.de_basics_images_logo.jpg","match":91,"jobs":13,"activity":1,"bookmarked":false},{"id":"17e0edbb845c3a9bbf4bdfd7aa32fd7b","cid":16271,"name":"Headhunter 5381171","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/1/6/2/7/1/p_https___www.leasotec.de_wp-content_themes_leasotec_library_img_leasotec_logo.jpg","match":90,"jobs":11,"activity":1,"bookmarked":false},{"id":"e809cf28622611298f4e8637ccf680ad","cid":9240,"name":"Headhunter 5374140","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/2/4/0/p_https___www.xing.com_img_custom_cpassets_logo_4_5_c_103516_logo_jobdistrict_variante_0220140305-20512-1v9ee4u.jpg","match":89,"jobs":10,"activity":1,"bookmarked":false},{"id":"d0df9e599ebbe8f831892f36e7cf2887","cid":2841,"name":"Headhunter 5367741","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/2/8/4/1/p_http___technicum.de_uploads_assets_logo-technicum.jpg","match":89,"jobs":10,"activity":3,"bookmarked":false},{"id":"a7c6a5405978a115d0f2e074b96ed00a","cid":9845,"name":"Headhunter 5374745","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/8/4/5/p_http___www.timepartner.com_assets_img_mobile_header_timepartner-bestpartner-logo1.jpg","match":88,"jobs":9,"activity":3,"bookmarked":false},{"id":"87db89210e5cbea70f719fba6a5c5849","cid":9580,"name":"Headhunter 5374480","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/5/8/0/p_http___rhh-cdn.npm13.net_var_ezflow_site_storage_images_media_images_logo_arbeit-und-mehr-logo_3372029-2-ger-DE_Arbeit-und-mehr-Logo_image_660.jpg","match":87,"jobs":8,"activity":1,"bookmarked":false},{"id":"8b58b759999522e7f72931b1c8cd1a31","cid":9932,"name":"Headhunter 5374832","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/9/3/2/p_https___www.xing.com_img_custom_cp_assets_logo_8_9_1_182417_logo_Stegmann.jpg","match":86,"jobs":8,"activity":1,"bookmarked":false},{"id":"be350619c0928967e7766700c71eb9cc","cid":10254,"name":"Headhunter 5375154","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/1/0/2/5/4/p_http___www.bs-wutow.de_img_partner_bswutow.jpg","match":86,"jobs":7,"activity":1,"bookmarked":false},{"id":"c61100eaf1556fe484243b8f63368ff8","cid":2374,"name":"Headhunter 5367274","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/2/3/7/4/p_http___www.openpr.de_images_articles_m_8_m82632778_g.jpg","match":85,"jobs":7,"activity":3,"bookmarked":false},{"id":"07b8e25fcdff238d0a4c64ed552e7caf","cid":9187,"name":"Headhunter 5374087","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/0/9/1/8/7/p_http___www.haaszeitarbeit.de_pics_haaslogo.jpg","match":84,"jobs":7,"activity":2,"bookmarked":false},{"id":"f8f18a22b51fa6af0d5180f222343dcc","cid":10603,"name":"Headhunter 5375503","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/1/0/6/0/3/p_http___www.stepstone.de_upload_de_logo_E_logoExpertalis-GmbH-DE.jpg","match":84,"jobs":6,"activity":2,"bookmarked":false},{"id":"72d44b61f8fbb937c8097e65e024d6ec","cid":45269,"name":"Headhunter 5410169","logo":"/data/dynamic/shared/companyExtern/0/0/0/0/0/0/4/5/2/6/9/p_https___assets.kununu.com_images_images_logos_akutmedizinische-personallogistik-gmbh-5102b.jpg","match":83,"jobs":5,"activity":1,"bookmarked":false}],"numberOfResults":146,"formattedNumberOfResults":"146","localizedNumberOfResults":"146 headhunters found"}
        const list = copy(data?.resultList || []);

        commit('setData', data);
        commit('setList', list);

        return getters.list;
      })
      .finally(() => {
        commit('setListRequestPending', false);
        commit('setSubmitted', true);
      });
  },
  fetchFacets({ commit, getters }, filters) {
    commit('setFacetsRequestPending', true);
    commit('setFacets', []);

    const cancelTokenSource = this.$api.CancelToken.source();

    return this.$api
      .post(this.getters.getApiLink('headhunterSearch.facets_v2'), filters, {
        cancelToken: cancelTokenSource.token,
      })
      .then(({ data }) => {
        commit('setFacets', {
          benchmarkFacets: data?.benchmarkFacets,
          branchFacets: data?.branchFacets,
          careerLevelFacets: data?.careerLevelFacets,
          channelFacets: data?.channelFacets,
          locationFacets: data?.locationFacets,
        });

        return getters.facets;
      })
      .finally(() => {
        commit('setFacetsRequestPending', false);
      });
  },

  async fetchPreview({ dispatch }, filters) {
    const url = `${this.getters.getApiLink('headhunterSearch.execute')}/preview`;
    const cancelTokenSource = this.$api.CancelToken.source();

    // fetch preview requires salary options, f.e for headhunter-preview-external page
    await dispatch('salary/getSalarySliderOptions', {}, { root:true });

    return this.$api
      .post(url, filtersToSearchRawParams(filters), {
        cancelToken: cancelTokenSource.token,
      })
      .then(({ data }) => data?.payload?.content?.resultList || []);
  },

  destroy({ commit, dispatch }) {
    commit('clearState');

    dispatch('cancelPendingRequests');
  },

  setFilters({ commit, rootGetters }, filters: unknown) {
    // set main filters
    (() => {
      const newMainFilters = Object.fromEntries(
        Object.entries(filters).filter(([key]) => mainFiltersList.includes(key)),
      );

      commit('setMainFilters', newMainFilters);
    })();

    // set extra filters
    (() => {
      const newExtraFilters = Object.fromEntries(
        Object.entries(filters).filter(([key]) => !mainFiltersList.includes(key)),
      );

      const { salary } = newExtraFilters;
      if (salary === null) {
        const country = newExtraFilters?.country || rootGetters['country/currentCountry'];
        const salaryOptions = rootGetters['salary/getSalaryOptions'](country.value);

        newExtraFilters.salary = [salaryOptions[0], salaryOptions[salaryOptions.length - 1]];
      }

      commit('setExtraFilters', newExtraFilters);
    })();
  },
  setItemBookmarkStatus({ state: currentState, commit }, item: BookmarkedAttrs) {
    const { list } = currentState;
    const index = list.findIndex(({ id }) => id === item.id);

    if (index > -1) {
      const formattedItem = copy(list[index]);
      formattedItem.bookmarked = item.value;
      commit('setBookmarked', { index, item: formattedItem });
    }
  },

  saveFilters({ commit }, filters) {
    const excludeKeys = ['startIndex'];

    const filteredFilters = Object.entries(filters).filter(([key]) => !excludeKeys.includes(key));
    const formattedFilters = Object.fromEntries(filteredFilters);
    commit('setLastFilters', formattedFilters);
  },
};

const getters = {
  isLoading: (s) => s.isInitialLoading || s.isListRequestPending || s.isFacetsRequestPending,
  isInitialLoading: (s) => s.isInitialLoading,
  isListRequestPending: (s) => s.isListRequestPending,
  isSubmitted: (s) => s.isSubmitted,
  list: (s) => s.list,
  options: (s) => {
    if (!s.facets) {
      return {};
    }

    const keys = {
      locationFacets: 'locations',
      careerLevelFacets: 'careerLevels',
      channelFacets: 'channels',
      branchFacets: 'branches',
    };

    return (() => {
      const formatItem = ({ name: label, id: value, frequency: number }) => ({
        label,
        value,
        number,
      });

      const result = Object.entries(keys)
        .filter(([key]) => s.facets[key] !== undefined)
        .map(([key, formattedKey]) => {
          const formattedValue = Object.entries(s.facets[key]?.facet || {})
            .map(([, item]) => item)
            .map((item: HeadhunterOptionsItem) => {
              if (item.children !== undefined) {
                return {
                  label: item.name,
                  options: Object.entries(item.children).map(([, v]) => formatItem(v)),
                };
              }

              return formatItem(item);
            });

          return [formattedKey, formattedValue];
        });

      return Object.fromEntries(result);
    })();
  },
  total: (s) => s.data?.numberOfResults,
  totalNumber: (currentState, currentGetters) => currentGetters.total || 0,
  totalText: (s) => s.data?.localizedNumberOfResults || translate('No headhunter found'),
  filters: (s) =>
    encodeExposedFilterParams({
      ...s.mainFilters,
      ...s.extraFilters,
    }),
  extraFilters: (s) => copy(s.extraFilters),
  limit: (s, g) => g.filters.limit || 25,
  activeFilters: (currentState, currentGetters, rootState, rootGetters) => {
    const { careerLevels, salary } = currentState.extraFilters;

    const country = currentState.extraFilters?.country || rootGetters['country/currentCountry'];
    const salaryOptions = rootGetters['salary/getSalaryOptions'](country.value);
    const defaultSalary = [salaryOptions[0], salaryOptions[salaryOptions.length - 1]];

    if (equals(salary, defaultSalary)) {
      return { careerLevels };
    }

    return {
      careerLevels,
      salary,
    };
  },

  lastFilters: (currentState, currentGetters, rootState, rootGetters) => {
    if (!currentState.lastFilters.professions?.length) {
      return currentState.lastFilters;
    }

    const currentProfessionsIds = currentState.lastFilters.professions.map(
      (profession) => profession.Id,
    );
    const professionsWithUpdatedLabels = rootGetters[
      'profession/professions'
    ].filter((properProfession) => currentProfessionsIds.includes(properProfession.Id));
    return {
      ...currentState.lastFilters,
      professions: professionsWithUpdatedLabels,
    };
  },
  requestParams: (s) => s.requestParams,
};

export default {
  namespaced: true,

  mutations,
  state,
  actions,
  getters,
};
